import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
    return out;
}

export function pushSupported() {
    return (
        typeof window !== "undefined"
        && "serviceWorker" in navigator
        && "PushManager" in window
        && "Notification" in window
    );
}

export function pushPermission() {
    return typeof Notification !== "undefined" ? Notification.permission : "unsupported";
}

export async function ensureServiceWorker() {
    if (!("serviceWorker" in navigator)) throw new Error("Service Worker no soportado");
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
    return reg;
}

export async function getCurrentSubscription() {
    if (!pushSupported()) return null;
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return null;
    return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
    if (!pushSupported()) throw new Error("Este dispositivo no soporta notificaciones push.");
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("Permiso de notificaciones denegado.");

    const reg = await ensureServiceWorker();

    const { data } = await api.get("/push/public-key");
    if (!data?.vapid_public_key) throw new Error("Servidor sin VAPID configurado.");

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(data.vapid_public_key),
        });
    }
    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
    return sub;
}

export async function unsubscribeFromPush() {
    const sub = await getCurrentSubscription();
    if (!sub) return;
    const json = sub.toJSON();
    try {
        await api.post("/push/unsubscribe", { endpoint: json.endpoint, keys: json.keys });
    } catch {
        // ignore
    }
    await sub.unsubscribe();
}
